<template>
  <v-form lazy-validation @submit.prevent="next" v-if="showPoolForm">
    <p class="text-left" style="font-size: 16px;"> Activa la casilla de las respuestas que consideras como respuestas de alerta.</p>
    <div v-for="(question, i) in this.pollForm.questions" :key="i" id="question-id">
      <v-layout wrap row class="questions-size">
        <v-flex xs6 md8 lg12>
          <v-textarea
            v-model="question.question"
            :prefix="(i + 1) + '.'"
            hide-details
            rows="1"
            auto-grow
            disabled
            counter
            maxlength="220"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap row class="questions-size">
        <v-flex xs12 md8 lg12>
          <v-select
            :items="types"
            item-text="name"
            item-value="value"
            v-model="question.type"
            required
            disabled
          />
        </v-flex>
      </v-layout>
      <div v-for="(answer, a) in question.answers" :key="a">
        <v-layout wrap row class="questions-size">
            <v-flex xs11 md8 lg10 px-3>
                <p style="margin-top: 16px;">{{ answer.answer }}</p>
            </v-flex>
            <v-flex lg2>
                <v-checkbox
                  color="primary"
                  v-model="answer.alert"
                ></v-checkbox>
            </v-flex>
        </v-layout>
      </div>
    </div>

      <v-divider style="margin-bottom: 20px"/>
      <v-layout wrap row class="questions-size" style="margin-bottom: 20px">
            <v-flex xs4 md4 lg4>
                <p style="margin-top: 16px;">¿Obligatoria para su ingreso?</p>
            </v-flex>

            <v-flex xs1 md1 lg1>
                <v-checkbox color="primary" @change="isRequiredEntry(true);" v-model="pollForm.requiredForEntry" label="Sí" />
            </v-flex>
            <v-flex xs1 md1 lg1>
                <v-checkbox color="primary" @change="isRequiredEntry(false);" v-model="noRequiredEntry" label="No"/>
            </v-flex>
        </v-layout>

      <v-divider style="margin-bottom: 0px"/>


      <v-layout wrap row class="questions-size" style="margin-bottom: 0px">
            <v-flex xs5 md5 lg5>
                <p class="text-left" style="font-size: 14px; margin-top: 20px;"> Notificar respuestas de alerta por correo a:</p>
            </v-flex>

            <v-flex xs1 md1 lg1>
              <v-checkbox color="primary" @change="isNotifyByEmail();" v-model="notifyByEmailModel"/>
            </v-flex>
      </v-layout>

      <v-layout wrap row class="questions-size" v-if="notifyByEmailModel">


        <v-flex md5>
        
          <v-text-field
            outline
            label="Correo"
            v-model="textBox"
            type=email
          >
            <template v-slot:append> 
              <v-btn icon @click="addChips"><v-icon >control_point</v-icon></v-btn>
            </template>
          </v-text-field>
          <template>
            <v-chip v-for="(chipText , index) in chipData" :key="index" @click="deleteChips(index)" class="gradiente white--text">{{chipText}}<v-icon right small>cancel</v-icon></v-chip>
          </template>
          <p class="error--text" v-if="ErrorEmailsEmpty">Por favor introduce al menos un correo</p>
        </v-flex>

      </v-layout>

      <v-divider style="margin-bottom: 20px"/>
      <p class="error--text" v-if="showErrorOnAdd">Por favor Activa la casilla de las respuestas que consideras como respuestas de alerta</p>
      
      <v-btn color="gradiente" dark round  @click="cancellPoll()">Cancelar</v-btn>
      <v-btn color="gradiente" dark round  @click="createPoll()">{{txtAddBtn}}</v-btn>



  </v-form>

  

</template>

<script>
import desition from "../../Dialogs/Confirm";

export default {
  components:{
    desition
  },
  props: ["poll", "isLocked", "showForm"],
  data: () => ({

    types: [
      {name: "SIMPLE", value: "SINGLE"},
      {name: "MULTIPLE", value: "MULTIPLE"},
      {name: "ABIERTA", value: "TEXT"}
    ],
    modals:{
      confirmDeleteQuestion: false
    },
    textBox: "",
    txtAddBtn:"Añadir",
    answersOld:[],
    noRequiredEntry: false,
    notifyByEmailModel: false,
    showErrorOnAdd: false,
    ErrorEmailsEmpty: false,
    pollForm: {},
    pollFormBorrador:{},
    chipData: [],
    showPoolForm: false,
    questionToDeleted: "",
    alreadyHavePoll:false,
    firtsEnter:true,
    isOpenForm: false,
  }),
  methods: {
    isRequiredEntry(value){

      if(value){
        this.pollForm.requiredForEntry = true;
        this.noRequiredEntry = false;
      }else{
        this.pollForm.requiredForEntry = false;
        this.noRequiredEntry = true;
      }

    },

    isNotifyByEmail(){
        console.log("notifyByEmailModel", );
        if (!this.notifyByEmailModel){
          this.pollForm.notifyByEmail = false;
          this.pollForm.theEmailsToNotify = []; 
          this.chipData = []
        }
        else{
          this.pollForm.notifyByEmail = true;
        }
    },

    removeQuestion(index) {
      this.questionToDeleted = index
      this.modals.confirmDeleteQuestion = true;
    },
    addStatus(question){
        question.answers.push({ alert: ""});
    },

    //HERE
    displayForm(value, info, visitPollForm){
      this.pollForm = visitPollForm;           
      this.showPoolForm = value;
      this.txtAddBtn = info;

      this.$emit("formIsOpen", true);
      // console.log("alreadyHavePoll", this.alreadyHavePoll);
      if(!value){
        //this.clearData();
      }
    },
    
    addChips() {
      // console.log("pollForm...", this.pollForm);
      this.ErrorEmailsEmpty = false;
      const emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
      this.textBox = this.textBox.toLowerCase()

      if (emailRegex.test(this.textBox)) {
        if (!this.chipData.includes(this.textBox)) {
          this.chipData.push(this.textBox);
          this.pollForm.theEmailsToNotify = this.chipData;
          // console.log("pollForm", this.pollForm);
        }

      this.textBox = ""
    }
              
  },
    
        deleteChips(id){
          this.chipData.splice(id, 1);
          this.pollForm.theEmailsToNotify = this.chipData;
          this.$forceUpdate();
        },

        //HERE
        cancellPoll(){
            this.showPoolForm = false;
            //this.clearData();
            // console.log("pollForm", this.pollForm);
            // this.$emit("updatePollForm", this.pollForm);
            this.$emit("formIsOpen", false);
        },

        createPoll(){
          // console.log("create Poll", this.pollForm);
          let answ = this.pollForm.questions[0].answers.length;
          let totalTrue = 0;
          
          this.showErrorOnAdd = false;
                
          let dataSend = {"displayBtn": true, "pollForm": this.pollForm}                
          let totalEmails = this.pollForm.theEmailsToNotify.length;

          if(this.notifyByEmailModel && totalEmails == 0){
            this.ErrorEmailsEmpty = true;
          }
          else{
            this.showPoolForm = false;
            this.ErrorEmailsEmpty = false;
            this.alreadyHavePoll = true;
            this.$emit("updatePollForm", this.pollForm);
            this.$emit("alreadyHavePoll", dataSend); //function, param
            this.$emit("formIsOpen", false);
          }

        },
        
        clearData(){
          this.pollForm = {
              questions: [
                {
                  question: "¿Usted presenta algunos de los siguientes síntomas",
                  type: "MULTIPLE",
                  answers: [
                    { answer: "Tos seca" },
                    { answer: "Dolor de cabeza"},
                    { answer: "Dificultad para respirar"},
                    { answer: "Malestar general"},
                    { answer: "Dolor de garganta"},
                    { answer: "Temperatura"},
                    { answer: "No presenta síntomas"}
                  ] 
                } 
              ],
              theEmailsToNotify: [],
              notifyByEmail: false,
              requiredForEntry: false,
            };
            this.chipData = [];
            this.notifyByEmailModel = false;
            this.showPoolForm = false;
            this.alreadyHavePoll = false;
            let dataSend = {"displayBtn": false, "pollForm":[]}
            this.$emit("alreadyHavePoll", dataSend); //
            this.$emit("updatePollForm", this.pollForm);
            this.$emit("clearPollForm");
            this.$emit("formIsOpen", false);
            
          }, 
  },
};
</script>

<style>
.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.questions-size .v-text-field {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.questions-size .v-input__slot {
  margin-bottom: 0 !important;
}

.questions-size .v-label{
  font-size: 14px !important;
}
.questions-size .v-input{
  font-size: 14px !important;
}

.questions-size .add-question-icon .v-btn{
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
<style scoped>
  .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
